import standardHandler from "./handlers/standardHandler";
import saleHandler from "./handlers/saleHandler";
import memberHandler from "./handlers/memberHandler";
import mapHandler from "./handlers/mapHandler";
import customizableHandler from "./handlers/customizableHandler";
import quantityDiscountHandler from "./handlers/quantityDiscountHandler";
import googleViewHandler from "./handlers/googleViewHandler";
import divideByHandler from "./handlers/divideByHandler";

export { default as PricingHandler } from "./contracts/PricingHandler";
export { default as IPricingComposite } from "./contracts/IPricingComposite";
export { default as IResolvedPricing } from "./contracts/IResolvedPricing";
export { default as usePricing, PricingProvider } from "./hooks/usePricing";

export { default } from "./evaluateDisplayPrice";

/**
 * Presets for handling common pricing scenarios
 * @remarks
 *  Comprehensive: Runs every handler in sequence, most likely used for PDP (Product Detail Page)
 */
export const presets = {
  comprehensiveEvaluation: [
    standardHandler,
    saleHandler,
    memberHandler,
    mapHandler,
    divideByHandler,
    quantityDiscountHandler,
    googleViewHandler,
    customizableHandler,
  ],
};

/**
 * Individual handlers for pricing resolution
 */
export const handlers = {
  standardHandler,
  saleHandler,
  memberHandler,
  mapHandler,
  customizableHandler,
  divideByHandler,
  quantityDiscountHandler,
  googleViewHandler,
};
